import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShoppingBag, ShoppingCart } from "lucide-react";
import api from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { Button } from "@/components/ui/button";
import { PageHeader, Money, EmptyState, Loading } from "@/components/common";

export default function Store() {
  const { addToCart } = useCart();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get("/products").then(({ data }) => { setProducts(data); setLoading(false); }); }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 py-10 min-h-[60vh]" data-testid="store-page">
      <PageHeader title="VIRIKS Store" subtitle="Books, notes & study material curated by experts" />
      {loading ? <Loading /> : products.length === 0 ? (
        <EmptyState icon={ShoppingBag} title="Store is empty" subtitle="Products will appear here soon." />
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {products.map((p) => {
            const price = p.discount_price || p.price;
            return (
              <div key={p.id} className="bg-white rounded-xl border border-border overflow-hidden hover:-translate-y-1 hover:shadow-lg transition-all" data-testid={`product-card-${p.id}`}>
                <div className="aspect-square bg-muted cursor-pointer" onClick={() => navigate(`/store/${p.id}`)}>
                  <img src={p.images?.[0]} alt={p.name} className="w-full h-full object-cover" />
                </div>
                <div className="p-4">
                  <h3 className="font-semibold text-navy line-clamp-2 text-sm h-10">{p.name}</h3>
                  <div className="flex items-center gap-2 mt-2">
                    <span className="font-heading font-black text-navy"><Money amount={price} /></span>
                    {p.discount_price > 0 && <span className="text-xs text-muted-foreground line-through"><Money amount={p.price} /></span>}
                  </div>
                  <Button className="w-full mt-3 viriks-navy text-white text-sm" onClick={() => addToCart({ type: "product", id: p.id, title: p.name, price, thumbnail: p.images?.[0] })} data-testid={`add-product-${p.id}`}>
                    <ShoppingCart size={15} className="mr-1" /> Add to Cart
                  </Button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
